// src/utils/deepseekStream.js

/**
 * DeepSeek 流式翻译封装工具
 * @param {string} apiKey - DeepSeek API Key
 * @param {string} model - 模型名称，默认 'deepseek-chat'
 */
export class DeepSeekStreamTranslator {
  constructor(apiKey, model = 'deepseek-chat') {
    this.apiKey = apiKey;
    this.model = model;
    this.controller = null; // 用于中止请求
  }

  /**
   * 发起流式翻译请求
   * @param {string} text - 待翻译文本
   * @param {string} targetLang - 目标语言（如 'zh'/'en'）
   * @param {function} onData - 接收到数据的回调 (content: string) => void
   * @param {function} onDone - 流结束的回调 () => void
   * @param {function} onError - 错误处理的回调 (error: Error) => void
   */
  async translate({ text, targetLang, onData, onDone, onError }) {
    this.controller = new AbortController();

    try {
      const response = await fetch('https://api.deepseek.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.apiKey}`,
        },
        body: JSON.stringify({
          model: this.model,
          messages: [
            {
              role: 'user',
              content: `将以下内容翻译成${targetLang === 'zh' ? '中文' : '英文'}：${text}`,
            },
          ],
          stream: true,
          temperature: 0.3,
        }),
        signal: this.controller.signal,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let fullContent = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value);
        const lines = chunk.split('\n').filter(line => line.trim() !== '');

        for (const line of lines) {
          if (line.startsWith('data:')) {
            const data = line.replace('data:', '').trim();
            if (data === '[DONE]') break;

            try {
              const parsed = JSON.parse(data);
              const content = parsed.choices[0]?.delta?.content || '';
              fullContent += content;
              onData?.(content); // 实时推送片段
            } catch (e) {
              console.error('解析错误:', e);
            }
          }
        }
      }

      onDone?.(fullContent); // 全部完成
    } catch (error) {
      if (error.name !== 'AbortError') {
        onError?.(error);
      }
    }
  }

  // 中止当前请求
  abort() {
    this.controller?.abort();
  }
}